import { useLocation } from 'react-router';
import { Button } from '@/components/ui/primitives/button';
import { usePrefixedNavigate } from '@/lib/auth/usePrefixedNavigate';

export default function NotFoundPage() {
  const location = useLocation();
  const navigate = usePrefixedNavigate();

  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6 text-center max-w-md px-4">
        <p className="text-7xl font-bold text-text-tertiary select-none">404</p>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-text-primary">
            Page not found
          </h1>
          <p className="text-text-secondary">
            The page{' '}
            <code className="rounded bg-bg-secondary px-1.5 py-0.5 text-sm font-mono text-text-primary">
              {location.pathname}
            </code>{' '}
            doesn&apos;t exist or has been moved.
          </p>
        </div>

        <div className="flex gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button variant="default" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
